// src/services/google/calendar.js


import { googleFetch } from './client';

export const calendarService = {
  /**
   * Lists primary calendar events between two dates.
   * @param {string} token - The OAuth Provider Token.
   * @param {Date} timeMin - Start date object.
   * @param {Date} timeMax - End date object.
   * @returns {Promise<Array>} A promise that resolves to an array of events.
   */
  listEvents: async (token, timeMin, timeMax) => {
    const params = new URLSearchParams({
      timeMin: timeMin.toISOString(),
      timeMax: timeMax.toISOString(),
      singleEvents: 'true', // Expand recurring events
      orderBy: 'startTime',
    });
    
    // The endpoint includes the primary calendar ID
    const data = await googleFetch(`/calendar/v3/calendars/primary/events?${params}`, token);
    return data.items || [];
  },

  /**
   * Creates an event on the primary calendar.
   * @param {string} token - The OAuth Provider Token.
   * @param {object} eventData - The event object (summary, start, end).
   * @returns {Promise<object>} A promise that resolves to the created event object.
   */
  createEvent: async (token, eventData) => {
    // The googleFetch client handles the JSON.stringify and headers for us
    return googleFetch('/calendar/v3/calendars/primary/events', token, {
      method: 'POST',
      body: JSON.stringify(eventData),
    });
  }
};

